module.exports = __webpack_public_path__ + "img/9.93d4eb84.svg";